//i18n.js
import Vue from 'vue'
// import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'


import en from '../locales/en.json'
import fr from '../locales/fr.json'
import esp from '../locales/esp.json'
import kor from '../locales/kor.json'
import tur from '../locales/tur.json'
import ita from '../locales/ita.json'
import arab from '../locales/arab.json'
import jp from '../locales/jp.json'
import rus from '../locales/rus.json'
import cn from '../locales/cn.json'

const messages = {
  cn,
  en,
  fr,
  esp,
  kor,
  tur,
  ita,
  arab,
  jp,
  rus
};

Vue.use(VueI18n)
//从localStorage获取语言选择
const i18n = new VueI18n({
// locale: localStorage.lang || navigator.language.toLowerCase(), //初始未选择浏览器默认语言 转换为小写 分别有zh zh-cn en en-us
  locale: localStorage.lang || 'en', //初始未选择浏览器默认语言 转换为小写 分别有zh zh-cn en en-us
  messages: messages
})
export default i18n



//////////////////
// WEBPACK FOOTER
// ./i18n/i18n.js
// module id = 770
// module chunks = 63